import { Grid, Button } from '@material-ui/core';
import colores from '../../shared/constants/styles';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import IRegistrarClienteRequest from './interface/IRegistrarClienteRequest';
import { enviarEmailRegistracion } from '../../actions/cliente';
import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from 'react';
import { Box, CircularProgress } from "@material-ui/core";
import IRecuperarContraseñaRequest from './interface/IRecuperarContraseñaRequest';
import { requestResetPassword } from '../../actions/auth';
import { Alert } from '@mui/material';

interface IContactoCardProps {
    id: number;
    clienteId: string;
    nroDocumento: string;
    nombre: string;
    email: string;
    contactoNro: string;
    createDate: string;
    enviadoEmail: string;
    primerInicio: string;
    data: any;
    successEnviado: any;
    successPasswordReset: any;
    errorPasswordReset: any;
    loadingEnviar: any;
    setSuccessEnviado: (success: boolean) => void;
    setErrorEnviado: (success: boolean) => void;
}

const ContactoCard = (props: IContactoCardProps) => {
    
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);  

    const onHandlerEnviarEmail = () => {
        setLoading(true);
        const registrarClienteRequest: IRegistrarClienteRequest ={
            clienteId: props.clienteId,
            contactoId: props.id,
            nombre: props.nombre,
            email: props.email
        }
        dispatch(enviarEmailRegistracion(registrarClienteRequest));
    };

    const onHandlerReestablecer= () => {
        setLoading(true);
        const recuperarContraseñaRequest: IRecuperarContraseñaRequest ={
            identification: props.nroDocumento,
            email: props.email
        }
        dispatch(requestResetPassword(recuperarContraseñaRequest));
    };

    useEffect(() => {
        if(!props.loadingEnviar){
            setLoading(false);
        }
    }, [props.loadingEnviar]);

    useEffect(() => {
        if(props.successEnviado){
            props.setSuccessEnviado(true);
        }
    }, [props.successEnviado]);

    useEffect(() => {
        if(props.successPasswordReset){
            props.setSuccessEnviado(true);
        }
    }, [props.successPasswordReset]);

    useEffect(() => {
        if(props.errorPasswordReset){
            setLoading(false);
            props.setErrorEnviado(true);
        }
    }, [props.errorPasswordReset]);

    

    return (
        <Grid className="bordesRedondos tienda" item xs={12} sm={6} md={4} lg={4} style={{marginBottom: "2.5rem"}}>
            <div className="bordesRedondosTop white-color p-4" style={{backgroundColor: colores.azulOscuro}}>
                <Grid container>
                    <Grid item xs={12} style={{ display: "flex", alignItems: "center" }}>
                        <PersonOutlineOutlinedIcon style={{fill: "white", width: "4vh", height: "4vh"}}/>  
                        <h5 style={{margin: "6px"}}>{props.nombre}</h5>
                    </Grid>
                </Grid>
            </div>
            <Grid item xs={12} style={{backgroundColor: colores.grisClaro}} className="bordesRedondosBottom p-4">
                <Grid item className="atributoTitle">Nro. Contacto</Grid>
                <Grid item className="atributoDato" style={{marginBottom: "1vh"}}>{props.contactoNro}</Grid>
                <Grid item className="atributoTitle">Email</Grid>
                <Grid item className="atributoDato" style={{marginBottom: "1vh"}}>{props.email}</Grid>
                <Grid item className="atributoTitle">Fecha de creación</Grid>
                <Grid item className="atributoDato" style={{marginBottom: "1vh"}}>{props.createDate}</Grid>
                <Grid item className="atributoTitle">Email de registración</Grid>
                <Grid item className="atributoDato" style={{marginBottom: "1vh"}}>{props.enviadoEmail? "Enviado": "No enviado"}</Grid>
                <Grid item className="atributoTitle">Primer ingreso</Grid>
                <Grid item className="atributoDato">{props.primerInicio? "Ingreso a Portalventas": "N/A"}</Grid>
                { loading ?
                    <Box sx={{ display: 'flex',  justifyContent: 'center' }}>
                        <CircularProgress />
                    </Box>:
                    <div>
                        <Button 
                            className="my-3"
                            style={{backgroundColor: colores.rojo, color: '#fff'}}
                            variant="contained"
                            onClick = {onHandlerEnviarEmail }
                        > 
                            Enviar Email de registración
                        </Button>
                        <Button 
                            className="my-3"
                            style={{backgroundColor: colores.rojo, color: '#fff'}}
                            variant="contained"
                            onClick = {onHandlerReestablecer }
                        > 
                            Reestablecer contraseña
                        </Button>
                    </div>
                }  
            </Grid> 
        </Grid>
    )
}
export default connect(
    (state: any) => ({
        successEnviado: state.clientes.successEnviado,
        successPasswordReset: state.auth.successPasswordReset,
        loadingEnviar: state.clientes.loadingEnviar,
        errorPasswordReset: state.auth.errorPasswordReset
    }),
    (dispatch) => ({
        enviarEmailRegistracion: (registrarClienteRequest: IRegistrarClienteRequest) => dispatch(enviarEmailRegistracion(registrarClienteRequest)),
        requestResetPassword: (data: FormData) => dispatch(requestResetPassword(data))
    })
)(ContactoCard);